import { Link, useLocation } from "react-router-dom";
import { cn } from "../utils/lib";
import { useUserContext } from "../Context/UserContext";
import { ReactComponent as Dashboard } from "../assets/SVG/dashboard.svg";
import { ReactComponent as Admin } from "../assets/SVG/admin.svg";
import { ReactComponent as Business } from "../assets/SVG/business.svg";
import { ReactComponent as Notifications } from "../assets/SVG/notifications.svg";
import { ReactComponent as Logout } from "../assets/SVG/logout.svg";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import Logo from "../assets/images/shenlaroche.png";
import LoadingSpinner from "./ui/LoadingSpinner";
import { useEffect, useState } from "react";
import { signOut } from "../utils/signOut";
import { HAI_READ_ONLY_GROUP, ORG_HIERARCHY_GROUP } from "../utils/URLS";
export default function Sidebar() {
  const [user, setUser] = useUserContext();
  const [loading, setLoading] = useState(false);
  const [isAdministrator, setIsAdministrator] = useState(false);
  const [isStaff, setIsStaff] = useState(false);
  const [hasOrgHierarchy, setHasOrgHierarchy] = useState(false);
  const [isHaiReadOnly, setIsHaiReadOnly] = useState(false);

  useEffect(() => {
    if (user) {
      setIsAdministrator(Boolean(user.groups?.includes?.("administrator")));
      setIsStaff(Boolean(user?.user?.is_staff));
      setIsHaiReadOnly(
        Boolean(
          !user?.user?.is_superuser &&
            user.groups?.includes?.(HAI_READ_ONLY_GROUP),
        ),
      );
      setHasOrgHierarchy(
        Boolean(
          user?.user?.is_superuser ||
            user.groups?.includes?.(ORG_HIERARCHY_GROUP) ||
            user.groups?.includes?.(HAI_READ_ONLY_GROUP),
        ),
      );
      setLoading(false);
    }
  }, [user]);

  const handleSignOut = () => {
    signOut({ setUser });
  };

  return (
    <div className="sticky top-0 flex h-screen w-[250px] flex-col md:w-[350px]">
      <div className="flex h-36 items-center justify-center bg-white" style={{"padding":40}}>
        <div className="p-4 text-2xl font-black uppercase" >
          <img src={Logo} alt="LOGO" />
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-2 bg-gradient-to-t from-[#1B1B1B] to-[#37383B] p-5">
        {loading ? (
          <div className="flex h-full w-full items-center justify-center">
            <LoadingSpinner />
          </div>
        ) : (
          <>
            
              <NavLink to="/dashboard">
                <div className="flex items-center gap-4">
                  <Dashboard className="h-7 w-7" />
                  <span>Dashboard</span>
                </div>
              </NavLink>
            
            {!isHaiReadOnly ? (
              <NavLink to="/companies">
                <div className="flex items-center gap-4">
                  <Business className="h-7 w-7" />
                  <span>Clients</span>
                </div>
              </NavLink>
            ) : null}
            {(isAdministrator || isStaff) ? (
              <NavLink to="/potential-clients">
                <div className="flex items-center gap-4">
                  <Business className="h-7 w-7 opacity-90" />
                  <span>Potential clients</span>
                </div>
              </NavLink>
            ) : null}
            {hasOrgHierarchy ? (
              <NavLink to="/org-hierarchy">
                <div className="flex items-center gap-4">
                  <ApartmentOutlinedIcon className="!h-7 !w-7" style={{ color: "white" }} />
                  <span>Halcyon Art International Limited</span>
                </div>
              </NavLink>
            ) : null}
            {isAdministrator && (
              <>
                <NavLink to="/notifications">
                  <div className="flex items-center gap-4">
                    <Notifications className="h-7 w-7" />
                    <span>Notifications</span>
                  </div>
                </NavLink>
                <NavLink to="/adminstration">
                  <div className="flex items-center gap-4">
                    <Admin className="h-7 w-7" style={{ color: "white" }} />
                    <span>Administration</span>
                  </div>
                </NavLink>
              </>
            )}

            <button
              onClick={handleSignOut}
              className="rounded-md px-5 py-4 font-medium leading-normal text-white transition hover:bg-[#4e4f52]"
            >
              <div className="flex items-center gap-4">
                <Logout />
                <span>Sign Out</span>
              </div>
            </button>

            <div className="mt-auto border-t border-white/10 px-2 pt-4 text-xs text-white/60">
              <p>
                © 2024 made by{" "}
                <a
                  href="/"
                  className="font-semibold text-white/80 transition hover:text-golden"
                >
                  Kusol Labs
                </a>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const NavLink = ({ to, children }) => {
  const { pathname } = useLocation();
  return (
    <Link
      to={to}
      className={cn(
        "rounded-md px-5 py-4 font-medium leading-normal text-white transition hover:bg-[#4e4f52]",
        {
          "bg-golden text-white": pathname === to,
        },
      )}
    >
      {children}
    </Link>
  );
};
